import React from 'react';
import { Box, Text, Flex, Link, useMediaQuery } from '@chakra-ui/react';
import ButtonPress from './ButtonPress';

const NavBar = ({ accounts, setAccounts}) => {
    const isConnected = Boolean(accounts[0]);
    const [isLargerThan800] = useMediaQuery('(min-width: 800px)');
    const [isLargerThan500] = useMediaQuery('(min-width: 500px)');

    async function connectAccount() {
        if (window.ethereum) {
            const accounts = await window.ethereum.request({
                method: 'eth_requestAccounts',
            });
            setAccounts(accounts);
        }
    }

    return (
        <Flex
            justify='space-between'
            align='center'
            padding='10px 0 10px 0'
            flexDirection={ isLargerThan800 ? 'row' : 'column'}
        >
            {/* Left Side - Social Media Icons */}
            <Flex
                justify='space-around'
                width={ isLargerThan800 ? '35%' : '100%' }
                gap={ isLargerThan500 ? '15px' : '' }
                align={ isLargerThan800 && 'center'}
                // padding={ isLargerThan800 ? '0 10px' : '0 60px'}
                flexDirection={ isLargerThan800 ? 'column' : 'row'}
            >
                <Link
                    href='https://etherscan.io/address/0xf69a205ff47ff3235dbf0f1e2a8765357fc2e81e'
                    target='_blank'
                    textDecoration='none'
                >
                    <ButtonPress
                        backgroundColor='#6a6e74'
                        borderRadius='5px'
                        boxShadow='2px 2px 2px 1px #0F0F0F'
                        textShadow='2px 2px 2px black'
                        color='white'
                        cursor='pointer'
                        fontFamily='inherit'
                        fontSize={ isLargerThan500 ? '24px' : '16px'}
                        padding='15px'
                        margin='0 15px'
                        width={ isLargerThan800 && '143px'}
                    >
                        Contract
                    </ButtonPress>
                </Link>
                <Link
                    href='https://opensea.io/collection/arrested-tate-jail-club'
                    target='_blank'
                    textDecoration='none'
                >
                    <ButtonPress
                        backgroundColor='#6a6e74'
                        borderRadius='5px'
                        boxShadow='2px 2px 2px 1px #0F0F0F'
                        textShadow='2px 2px 2px black'
                        color='white'
                        cursor='pointer'
                        fontFamily='inherit'
                        fontSize={ isLargerThan500 ? '24px' : '16px'}
                        padding='15px'
                        margin='0 15px'
                        width={ isLargerThan800 && '143px'}
                    >
                        OpenSea
                    </ButtonPress>
                </Link>
                <Link
                    href='https://twitter.com/TateJailClub'
                    target='_blank'
                    textDecoration='none'
                >
                    <ButtonPress
                        backgroundColor='#6a6e74'
                        borderRadius='5px'
                        boxShadow='2px 2px 2px 1px #0F0F0F'
                        textShadow='2px 2px 2px black'
                        color='white'
                        cursor='pointer'
                        fontFamily='inherit'
                        fontSize={ isLargerThan500 ? '24px' : '16px'}
                        padding='15px'
                        margin='0 15px'
                        width={ isLargerThan800 && '143px'}
                    >
                        Twitter
                    </ButtonPress>
                </Link>
            </Flex>

            <Flex justify='space-around' align='center' width={ isLargerThan800 ? '35%' : '100%' } padding='20px'>
                <Text
                    fontSize={ isLargerThan500 ? '40px' : '30px'}
                    >
                        Arrested Tate Jail Club
                </Text>
            </Flex>

            {/* Right Side - Connect*/}
            <Flex
                id='connect-wrapper'
                justify='space-around'
                align='center'
                width={ isLargerThan800 ? '35%' : '100%' }
            >

            {/* Connect */}
            {isConnected ? (
                <Box 
                    margin='0 15px'
                    fontSize='24px'
                    textShadow='2px 2px 2px black'
                    >
                        Connected</Box>
            ) : (
                <ButtonPress
                    backgroundColor='#6a6e74'
                    borderRadius='5px'
                    boxShadow='2px 2px 2px 1px #0F0F0F'
                    textShadow='2px 2px 2px black'
                    color='white'
                    cursor='pointer'
                    fontFamily='inherit'
                    fontSize='24px'
                    padding='15px'
                    margin='0 15px'
                    onClick={connectAccount}
                >
                    Connect
                </ButtonPress>
            )}

            </Flex>


        </Flex>
    );
};

export default NavBar;